/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgentDataTableConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AiAgentDataTableConfiguration");
    }

    getFixupPrototypeFunction() { return AiAgentDataTableConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AiAgentDataTableConfiguration>): AiAgentDataTableConfiguration {
        let obj = Object.assign(new AiAgentDataTableConfiguration(), model);
        AiAgentDataTableConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgentDataTableConfiguration>): AiAgentDataTableConfiguration {
        if (!model) return null;
        return AiAgentDataTableConfiguration.newInstance(<AiAgentDataTableConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgentDataTableConfiguration) {
        if (!obj) return;

        models.AiAgentDataTableConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgentDataTableConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiAgentDataTableConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
